import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import type { VisitTypeErrorState } from './types'

export const maxTextLength = {
  SERVICE_NAME: 70,
  DESCRIPTION: 500,
  SERVICE_ABBREVIATION: 4,
} as const

export const text = {
  VISIT_NAME: 'Visit name',
  DESCRIPTION: 'Description',
  COST_USD: 'Cost (USD)',
  CANCELLATION_FEE: 'Cancellation fee',
  CONSENT_FORMS: 'Consent forms',
  INTAKE_FORM: 'Intake form',
  VISIT_LENGTH: 'Visit length',
  CANCELATION_FEE_USD: 'Cancellation fee (USD)',
  COST_USD_FIELD_VALUE: 'Cost (USD) field value',
  SERVICE_ABBREVIATION: 'Service abbreviation',
  SERVICE_NAME: 'Service name',
  SERVICE_TYPE: 'Service type',
  NEW_SERVICE_TYPE: 'New service type',
  CREATE_BTN: 'Create',
  CANCEL_BTN: 'Cancel',
} as const

export const serviceTypeTableDefaultErrorsConfig: VisitTypeErrorState = {
  id: '',
  errors: {
    visitLengthError: '',
    visitLengthLocalError: '',
    coastUSDError: '',
    coastUSDLocalError: '',
    cancellationFeeError: '',
    cancellationFeeLocalError: '',
    visitNameError: '',
    visitNameLocalError: '',
    intakeFormError: '',
    intakeFormLocalError: '',
    visitDescriptionError: '',
    visitDescriptionLocalError: '',
    consentFormError: '',
    consentFormLocalError: '',
    visibilityTypeError: '',
  },
}

export const toastErrorsList: string[] = [
  getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION),
  getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
  getUserFriendlyErrorMessage(errorCodes.DEFAULT),
]
